export enum CplItemPermissions {
    CAN_VIEW_ITEM = 1,
    CAN_REQUEST_ACCESS = 2,
    CAN_MANAGE_ITEM = 10,
    CAN_EDIT_ITEM = 100,
    CAN_TOGGLE_PRIVACY = 200,
    CAN_EDIT_ITEM_PACKETS = 800
}